var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_2_a{fill:#2e9e9e;}.step_2_b{clip-path:url(#a);}.step_2_c{fill:#1b205a;opacity:0.45;}.step_2_d{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_2_a",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(156 1347)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-529 -1347)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_2_a",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(529 1347)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "step_2_b",
    transform: "translate(373)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "step_2_c",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(121 1379)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(583 1389.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "step_2_d",
    d: "M199.16,71.844l.75-.469a5.9,5.9,0,0,0,1.968-8.057,5.677,5.677,0,0,0-1.78-1.873A5.866,5.866,0,0,0,198.5,51.234v-20.7a3.658,3.658,0,0,0-3.654-3.654H159.439a3.658,3.658,0,0,0-3.654,3.654V59.853a8.135,8.135,0,0,0-3.654-.937h-.093a4.9,4.9,0,0,0-3.466,1.5,4.381,4.381,0,0,0-1.312,3.466c.188,3.747-.656,9.275-1.4,13.209a25.316,25.316,0,0,0,.562,11.241l2.061,6.839-5.058,6.089a1.78,1.78,0,0,0,.188,2.53,1.973,1.973,0,0,0,1.218.469,1.685,1.685,0,0,0,1.4-.656l5.714-6.839a1.854,1.854,0,0,0,.374-1.686L149.978,87.3a19.1,19.1,0,0,1-.469-9.462c.75-4.122,1.686-9.93,1.4-14.052a1.132,1.132,0,0,1,.281-.75,1.12,1.12,0,0,1,.75-.374h.093a4.018,4.018,0,0,1,3.654,2.436V92.453a3.658,3.658,0,0,0,3.654,3.654H183.7a29.418,29.418,0,0,1-6.183,4.591,9.988,9.988,0,0,1-1.78.843,2.261,2.261,0,0,0-.937.937l-2.716,6.277a1.891,1.891,0,0,0,.937,2.436,2.211,2.211,0,0,0,.75.188,1.714,1.714,0,0,0,1.686-1.124l2.436-5.621c.469-.188.843-.469,1.311-.656a34.145,34.145,0,0,0,9.462-7.775h.469a5.814,5.814,0,0,0,3-.843l5.527-3.372a5.9,5.9,0,0,0,1.968-8.057,6.151,6.151,0,0,0-1.686-1.78l.843-.469a5.851,5.851,0,0,0,2.623-3.654,6.011,6.011,0,0,0-.656-4.4,4.876,4.876,0,0,0-1.592-1.779Zm-39.721-32.6h35.411V51.328a2.9,2.9,0,0,0-1.218.562l-5.527,3.372a5.9,5.9,0,0,0-1.968,8.057,5.677,5.677,0,0,0,1.78,1.873,5.85,5.85,0,0,0-1.5,7.682,5.436,5.436,0,0,0,1.592,1.686l-.75.469a5.9,5.9,0,0,0-1.968,8.057,2.836,2.836,0,0,0,.469.656H159.439Zm38.6,29.041-5.527,3.372a2.185,2.185,0,0,1-2.249-3.748l5.527-3.372a2.491,2.491,0,0,1,1.124-.281,2.158,2.158,0,0,1,1.873,1.031,2.228,2.228,0,0,1-.749,3Zm-6.651,13.584a2.185,2.185,0,0,1-2.249-3.748l5.527-3.372a2.491,2.491,0,0,1,1.124-.281,2.158,2.158,0,0,1,1.873,1.031,2.6,2.6,0,0,1,.281,1.686,1.811,1.811,0,0,1-1.031,1.311Zm6.37-23.139L192.228,62.1a2.6,2.6,0,0,1-1.686.281,1.811,1.811,0,0,1-1.312-1.031,2.167,2.167,0,0,1,.75-3l5.527-3.372a.716.716,0,0,1,.469-.188h1.312a2.4,2.4,0,0,1,1.218.937,2.23,2.23,0,0,1-.75,3Zm-2.9-28.2V35.59H159.44V30.532ZM159.44,87.3h24.732a5.542,5.542,0,0,0-.374,5.153H159.44Zm36.442,1.5-5.527,3.372a2.167,2.167,0,0,1-3-.75,2.6,2.6,0,0,1-.281-1.686,1.811,1.811,0,0,1,1.031-1.311l5.527-3.372a2.491,2.491,0,0,1,1.124-.281A2.158,2.158,0,0,1,196.63,85.8a2.228,2.228,0,0,1-.749,3Z",
    transform: "translate(-142.982 -26.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "step_2_d",
    d: "M341.236,396.858a1.5,1.5,0,1,1-1.5-1.5,1.5,1.5,0,0,1,1.5,1.5",
    transform: "translate(-305.574 -333.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "step_2_d",
    d: "M312.114,55.271h8.806a1.873,1.873,0,1,0,0-3.747h-8.806a1.873,1.873,0,1,0,0,3.747Z",
    transform: "translate(-282.261 -47.401)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "step_2_d",
    d: "M79.7,0a9.7,9.7,0,1,0,9.7,9.7A9.728,9.728,0,0,0,79.7,0ZM72.91,5.82h9.7V3.88l2.91,2.91L82.609,9.7V7.76h-9.7Zm13.579,7.76h-9.7v1.94l-2.91-2.91L76.79,9.7v1.94h9.7Z",
    transform: "translate(-45.699 24.823)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.117ee094300694e5050a1d4bbf505971.svg";
export { ForwardRef as ReactComponent };